import {TimelineReelsController} from "@nolimitcity/slot-game/bin/timelinegameround/reels/TimelineReelsController";
import {IReelStoppedData, ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {HorribleHeroesParsedGameData} from "../server/data/HorribleHeroesParsedGameData";
import {HorribleHeroesGameModuleConfig} from "../HorribleHeroesGameModuleConfig";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {HorribleHeroesReelController} from "./HorribleHeroesReelController";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {TimelineLite, TweenLite} from "gsap";
import {HorribleHeroesGameConfig} from "../HorribleHeroesGameConfig";
import {SoundManager} from "../resource/sound/SoundManager";
import {HorribleHeroesSoundConfig} from "../HorribleHeroesSoundConfig";
import {HorribleHeroesGameMode} from "../HorribleHeroesGameMode";
import {HorribleHeroesSymbolL} from "../symbols/HorribleHeroesSymbolL";
import {TrailReelSymbol} from "../symbols/TrailReelSymbol";
import {HorribleHeroesSymbolMX} from "../symbols/HorribleHeroesSymbolMX";
import {IStickyObject} from "../views/StickyWildsView";
import {HorribleHeroesReelSymbol} from "../symbols/HorribleHeroesReelSymbol";

export class HorribleHeroesTimelineReelsController extends TimelineReelsController {
    private static hasAnticipationPlayed: boolean = false;

    private _nearWinReels: boolean[] = [];
    private _scatterPositions: number[] = [];
    private _wasFeatureBuy: boolean = false;
    private _scatterSymbols: StateReelSymbol[] = [];
    private _isXWayExpanded: boolean = false;
    private _stickyTl: TimelineLite;
    private _gameData: HorribleHeroesParsedGameData;
    private _scatterLength: number = 0;
    private _wildLandingLockSoundPlayed: boolean = false;
    private _xWaysLandingSoundPlayed: boolean = false;
    private _xWaysElectricitySoundPlayed: boolean = false;
    private _xWaysAnticipationSoundPlayed: boolean = false;
    private _collecMeterDelay: number = 0;
    private _mxLandingSoundPlayed: boolean[] = [false, false, false, false, false];

    private static playLandingSound(data: IReelStoppedData): void {
        const lastReelId: number = HorribleHeroesGameConfig.instance.REELS_NUM - 1;

        if (this.hasAnticipationPlayed) {
            // #450
            SoundManager.playReelLanding(data.reelId);
        } else if ((data.fastSpin || data.quickStop) && (data.reelId % 2 === 0)) {
            SoundManager.playReelLanding(data.reelId);
        } else if (!data.fastSpin && !data.quickStop) {
            SoundManager.playReelLanding(data.reelId);
        }

        if (data.reelId === lastReelId) {
            SoundManager.stopSound(HorribleHeroesSoundConfig.instance.REELS_SPIN);
        }
    }

    // #393
    public startSpin(reelId: number): TimelineLite {
        this.resetAllScatters(reelId);

        return super.startSpin(reelId);
    }

    protected addEventListeners(): void {
        super.addEventListeners();
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event: GameEvent) => this.onGameDataParsed(event.params[0]));
    }

    protected onReelBounceStarted(stopData: IReelStoppedData): void {
        HorribleHeroesTimelineReelsController.playLandingSound(stopData);

        //#337
        // #331 moved from ReelStop.ts to here
        //#569 passing quickstop as parameter
        (Reels.getReel(stopData.reelId)! as HorribleHeroesReelController).playPartialWinAnimation(stopData.quickStop);
        // #280

        //#490
        //#569 moved fromReelControler
        if (this.toCheckXExpandedBefore(this._gameData.isXWayExpanded, stopData.reelId)) {
            (Reels.getReel(stopData.reelId)! as HorribleHeroesReelController)!.playXPotentialWinAnimation(stopData.quickStop);
        }
        this.tryScatterLandingAnimations(stopData);

        //#475  duration to be added while scatter trigger is played
        const duration: number = this.playCollectMeterAnimation(stopData.reelId).totalDuration();
        const lastReelId: number = HorribleHeroesGameConfig.instance.REELS_NUM - 1;
        if (stopData.reelId === lastReelId) {
            this._collecMeterDelay = duration;
        }
        // #329
        HorribleHeroesGameModuleConfig.nearWinView.stopAllAnimations();
        HorribleHeroesGameModuleConfig.nearWinView.fadeOutAnimation();
        if (!stopData.quickStop) {
            const reelId: number = (stopData.reelId + 1);
            if ((this._nearWinReels[reelId])) {
                HorribleHeroesGameModuleConfig.nearWinView.playSparkAnimation(reelId);
                HorribleHeroesGameModuleConfig.nearWinView.fadeInAnimation();

                // #410
                if (this._scatterSymbols.length === 2 && !HorribleHeroesTimelineReelsController.hasAnticipationPlayed) {
                    SoundManager.playScatterAnticipation();
                    HorribleHeroesTimelineReelsController.hasAnticipationPlayed = true;
                }

                // #479
                if (this._gameData.bonusPositions[stopData.reelId] > -1 && !this._xWaysAnticipationSoundPlayed) {
                    SoundManager.playXWaysAnticipation();
                    this._xWaysAnticipationSoundPlayed = true;
                }
            }
        }
        //#532 #555
        //to make sure W is replace by "L1" on the reel before X expands
        if (this._stickyTl && this._stickyTl.totalProgress() < 1) {
            this._stickyTl.totalProgress(1);
        }
        //#336
        this.tryPlayStickyWildAnimation(stopData);

        if (stopData.reelId === lastReelId) {
            // #410
            if (HorribleHeroesTimelineReelsController.hasAnticipationPlayed) {
                if (this._scatterSymbols.length > 2) {
                    SoundManager.playScatterAnticipationWin();
                } else {
                    SoundManager.playScatterAnticipationFail();
                }

                SoundManager.stopSound(HorribleHeroesSoundConfig.instance.SCATTER_ANTICIPATION);
                SoundManager.stopSound(HorribleHeroesSoundConfig.instance.SCATTER_ANTICIPATION_ALARM);
            }

            // #479
            if (this._xWaysAnticipationSoundPlayed) {
                SoundManager.stopSound(HorribleHeroesSoundConfig.instance.X_WAYS_ANTICIPATION);
            }

            // #483
            if (!this._wasFeatureBuy && this._gameData.mode === HorribleHeroesGameMode.NORMAL && this._gameData.nextMode === HorribleHeroesGameMode.FREESPIN_PICK) {
                SoundManager.playFSWinAttention();
            }
        }

        // #441
        const reel: string[] = this._gameData.reels[stopData.reelId];
        // visible symbols only
        for (let i: number = 1; i < (reel.length - 1); i++) {
            if (reel[i] === "X") {
                if (!stopData.quickStop) {
                    this.playXWaysLandingSound();
                } else if (!this._xWaysLandingSoundPlayed && stopData.quickStop) {
                    this._xWaysLandingSoundPlayed = true;
                    this.playXWaysLandingSound();
                }
            }
            if (reel[i] === "MX") {
                //#395
                this.tryPlayMXLandingAnimations(stopData, i - 1);
            }
        }

        super.onReelBounceStarted(stopData);
    }

    protected onReelSpinAnimationStopped(stopData: IReelStoppedData): void {
        super.onReelSpinAnimationStopped(stopData);
        //#532 #555
        //to make sure W is replace by "L1" on the reel before X expands
        if (this._stickyTl && this._stickyTl.totalProgress() < 1) {
            this._stickyTl.totalProgress(1);
        }
        //#395
        // to show the MX land animation
        TweenLite.delayedCall(0.333, () => this.resetLandingAnimations(stopData.reelId));
        this.resetTrailSymbols(stopData.reelId);


        const lastReelId: number = HorribleHeroesGameConfig.instance.REELS_NUM - 1;
        if (stopData.reelId === lastReelId) {
            //#569 dee9ea10
            this._gameData.getPotentialSymbolPostions.forEach((pos: boolean[], i: number) => {
                for (let j = 0; j < this._gameData.getGameAreaSizeAfter[i]; j++) {
                    const symbol: HorribleHeroesReelSymbol = <HorribleHeroesReelSymbol>Reels.getSymbol(i, j);
                    symbol && symbol.stopHighlightWin();
                }
            });
            //moved from reelController
            if (!this._scatterSymbols.length) {
                return;
            }
            let delay: number = 0;
            // adding delay to show the animation on scatter landed on last reel
            if ((!stopData.quickStop) && (!this._wasFeatureBuy)) {
                if (this._scatterSymbols[this._scatterSymbols.length - 1].reelId === lastReelId) {
                    // #393
                    if (this._scatterSymbols.length > 2) {
                        delay = 1.5; // to show the trigger animation of scatter symbols

                        // #543
                        if (this._isXWayExpanded) {
                            HorribleHeroesGameConfig.instance.FS_TRIGGER_DELAY = 1.5;
                        }
                    } else {
                        delay = 0.333; // to show the scatter land animation
                    }
                }
            }

            // #475
            if (!this._wasFeatureBuy && this._scatterSymbols.length === 5) {
                delay = delay + this._collecMeterDelay;
            }
            TweenLite.delayedCall(delay, () => this.resetAllScatters(0));
            //#475 to show trigger till meter animation played
        }
    }

    private toCheckXExpandedBefore(xWayExpand: boolean[], currentReelId: number): boolean {
        let hasXExpanded: boolean = false;
        for (let reelId: number = 0; reelId <= currentReelId; reelId++) {
            if (xWayExpand[reelId]) {
                hasXExpanded = true;
                break;
            }
        }
        return hasXExpanded;
    }

    private tryPlayMXLandingAnimations(stopData: IReelStoppedData, symId: number): void {
        const reelId: number = stopData.reelId,
            sym: StateReelSymbol = Reels.getSymbol(reelId, symId)!;

        if ((sym.symName === "MX")) {
            // #539
            if (!this._mxLandingSoundPlayed[reelId]) {
                this._mxLandingSoundPlayed[reelId] = true;

                SoundManager.playMXLanding();
            }

            //delay added to sync with reelBounce
            TweenLite.delayedCall(0.1, () => (sym! as HorribleHeroesSymbolMX).playLandingAnimation());
        }
    }

    private tryPlayStickyWildAnimation(stopData: IReelStoppedData): void {
        const reelId: number = stopData.reelId;

        this._stickyTl = new TimelineLite({
            onComplete: () => {
                this._stickyTl.pause();
                this._stickyTl.kill();
                this._stickyTl.clear();
            }
        });
        const stickyWildWinObj: IStickyObject = HorribleHeroesGameModuleConfig.stickyWilds.addDelayToReel(stopData.reelId + 1);
        if (stickyWildWinObj.isSticky) {
            this._stickyTl.add([
                () => {
                    //#493  removed wild landing as it was overlapping with stickyLockAnimation
                    // #441, #530
                    if (!stopData.quickStop) {
                        SoundManager.playWildLandingLock();
                    } else if (!this._wildLandingLockSoundPlayed && stopData.quickStop) {
                        this._wildLandingLockSoundPlayed = true;
                        SoundManager.playWildLandingLock();
                    }

                    // #466
                    HorribleHeroesGameModuleConfig.logoAnimations.playAnimationsOnWin(this._gameData.mode, this._gameData.getExpandedSymbol);
                },
                HorribleHeroesGameModuleConfig.stickyWilds.showStickyWilds(reelId)
            ], 0);
            // #377
            this._stickyTl.add(() => {
                if (this._gameData.nextMode !== HorribleHeroesGameMode.NORMAL) {
                    let reelController: ReelController = Reels.getReel(reelId)!;

                    for (let i: number = 0; i < this._gameData.lockedWildNextSpin[reelId].length; i++) {
                        if (this._gameData.lockedWildNextSpin[reelId][i]) {
                            Reels.getSymbol(reelId, i)!.setVisibility(false);

                            if (reelController) {
                                const newSym: HorribleHeroesSymbolL = new HorribleHeroesSymbolL("L1", reelId, HorribleHeroesGameConfig.instance.SYMBOL_STATES.normal),
                                    currSym: HorribleHeroesReelSymbol = (reelController.findSymbol(i)! as HorribleHeroesReelSymbol);

                                if (currSym) {
                                    newSym.position.set(currSym.x, currSym.y);
                                    // #247
                                    currSym.stopWinFireAnimation();

                                    reelController.removedChildOnView(currSym);

                                    reelController.allSymbols.splice(i + 1, 1, newSym);
                                    reelController.addChildOnView(newSym);
                                }
                            }
                        }
                    }
                }
            });
        }
        HorribleHeroesGameModuleConfig.stickyWilds.setQuickstop(stopData.quickStop);
    }

    private onGameDataParsed(data: HorribleHeroesParsedGameData): void {
        this._scatterPositions = data.scatterPositions || [-1, -1, -1, -1, -1];
        this._nearWinReels = data.nearWinReels;

        this._wasFeatureBuy = data.wasFeatureBuy;

        this._isXWayExpanded = data.isXWayExpanded.indexOf(true) > -1;

        this._scatterSymbols = [];
        HorribleHeroesTimelineReelsController.hasAnticipationPlayed = false;
        this._scatterLength = 0;
        this._gameData = data!;

        // #441
        this._wildLandingLockSoundPlayed = false;
        this._xWaysLandingSoundPlayed = false;
        this._xWaysElectricitySoundPlayed = false;

        // #479
        this._xWaysAnticipationSoundPlayed = false;

        // #539
        this._mxLandingSoundPlayed = [false, false, false, false, false];

        // #543
        HorribleHeroesGameConfig.instance.FS_TRIGGER_DELAY = 0;
    }

    private tryScatterLandingAnimations(data: IReelStoppedData): void {
        const reelId: number = data.reelId,
            quickStop: boolean = data.quickStop,
            lastReelId: number = (HorribleHeroesGameConfig.instance.REELS_NUM - 1),
            scatterPos: number = this._scatterPositions[reelId];

        let scatterCount: number = 0;
        // David wants, if we have the 5th scatter landing in FS then we shall play "scatter5" no matter what, otherwise regular scatter land count.
        if (this._gameData.mode.indexOf("FREESPIN") > -1) {
            scatterCount = HorribleHeroesGameModuleConfig.scatterPlusOne.getCurrentScatterSpins(reelId).scatterCollected;
        }

        if (scatterPos > -1) {
            const sym: StateReelSymbol = Reels.getSymbol(reelId, scatterPos)!;
            if (sym) {
                this._scatterSymbols.push(sym);

                // #386, #418 -> scatter is implemented as overlay now.
                sym.setVisibility(false);
                HorribleHeroesGameModuleConfig.scatterOverlayView.playLandingAnimation(reelId, scatterPos);

                const length: number = this._scatterSymbols.length;
                if (scatterCount > 3) {
                    // in FS, play scatter5 if total collected scatters count is 5
                    if (scatterCount === 5) {
                        this._scatterLength = length;
                        SoundManager.playScatter(scatterCount);
                    }
                    // otherwise play scatter1 when total collected scatters count is 4
                    else {
                        this._scatterLength = length;
                        SoundManager.playScatter(1);
                    }
                }
                // #449 -> check has been modified that if there are no chances of FS getting triggered, then don't play the scatter land sounds and play scatterFail.
                else if (!quickStop) {
                    this._scatterLength = length;
                    if (this.checkChanceOfFSTrigger()) {
                        SoundManager.playScatter(length);
                    } else {
                        SoundManager.playScatterFail();
                    }
                } else if (reelId === lastReelId && quickStop && this._scatterLength !== this._scatterSymbols.length) {
                    if (this.checkChanceOfFSTrigger()) {
                        SoundManager.playScatter(length);
                    } else {
                        SoundManager.playScatterFail();
                    }
                }
                //#575
                HorribleHeroesGameModuleConfig.reelBackGroundView.setIsQuickstop(quickStop, this._gameData.scatterCountValue);
                if (!this._wasFeatureBuy && !quickStop) {
                    if (length > 1) {
                        let level: string = "2";
                        if (length > 2) {
                            level = "3";
                        }
                        //#575
                        // not play if 2nd scatter lands on last reel
                        if (!(this._gameData.scatterPositions![4] > -1 && this._gameData.scatterCountValue === 2)) {
                            HorribleHeroesGameModuleConfig.reelBackGroundView.shakeStageEffect();
                            HorribleHeroesGameModuleConfig.reelBackGroundView.playChainAnimation(level);
                            if (this._gameData.mode.indexOf("FREESPIN") === -1) {
                                //#385
                                HorribleHeroesGameModuleConfig.background.playFireAnimationLevel(level);
                            }
                        }
                    }

                    // #410
                    if (length === 3 && reelId !== lastReelId) {
                        SoundManager.playScatterAnticipationAlarm();
                    }

                    TweenLite.delayedCall(0.66666, () => {
                        // since sym can be null later on, length check is for handling quick stop
                        if (sym && length > 0) {
                            // more than 2 syms
                            if (length > 2) {
                                if (sym.symName === "S" && sym.stackedSymName) {
                                    HorribleHeroesGameModuleConfig.scatterOverlayView.playTriggerAnimation(reelId, scatterPos);

                                    // #410
                                    SoundManager.playScatterExplode();
                                }
                            } else if (length === 2) { // #423
                                this._scatterSymbols.forEach((symbol: StateReelSymbol) => {
                                    if (symbol.symName === "S" && symbol.stackedSymName) {
                                        HorribleHeroesGameModuleConfig.scatterOverlayView.playLoopStartAnimation(symbol.reelId, this._scatterPositions[symbol.reelId]);
                                    }
                                });
                            }
                        }
                    });
                }
            }
        } else if (reelId === lastReelId && quickStop && this._scatterLength !== this._scatterSymbols.length) {
            // in FS, play scatter5 if total collected scatters count is 5
            if (scatterCount === 5) {
                SoundManager.playScatter((scatterCount));
            }
            // otherwise play scatter1 when total collected scatters count is 4
            else if (scatterCount === 4) {
                SoundManager.playScatter((1));
            } else {
                if (this.checkChanceOfFSTrigger()) {
                    SoundManager.playScatter(this._scatterSymbols.length);
                } else {
                    SoundManager.playScatterFail();
                }
            }
        }
    }

    //#298
    private playCollectMeterAnimation(reelId: number): TimelineLite {
        let scatterLength: number = this._scatterSymbols.length;
        const tl: TimelineLite = new TimelineLite();
        if (this._gameData.getScattersCollected > 2 && this._gameData.mode.indexOf("FREESPIN") > -1) {
            scatterLength = HorribleHeroesGameModuleConfig.scatterPlusOne.getCurrentScatterSpins(reelId).scatterCollected;
            if (this._scatterPositions[reelId] > -1) {
                tl.add(HorribleHeroesGameModuleConfig.scatterCollecMeter.playScatterCollectState(scatterLength));
            }
            //for freeSpins
        } else {
            //for BaseGame
            if (this._scatterPositions[reelId] > -1) {
                tl.add(HorribleHeroesGameModuleConfig.scatterCollecMeter.playScatterCollectState(scatterLength));
            }
            if (reelId === 4 && scatterLength < 3) {
                //for last reel
                scatterLength = 0;
                TweenLite.delayedCall(0.66666, () => {
                    //#298
                    HorribleHeroesGameModuleConfig.scatterCollecMeter.playScatterCollectState(scatterLength);
                });
            }
        }
        return tl;
    }

    // #393
    private resetAllScatters(reelId: number): void {
        if (reelId === 0 && this._scatterSymbols.length > 0) {
            this._scatterSymbols.forEach((sym: StateReelSymbol) => {
                sym.changeState({
                    state: HorribleHeroesGameConfig.instance.SYMBOL_STATES.normal
                });
                sym.setVisibility(true);
            });
            this._scatterSymbols = [];

            HorribleHeroesGameModuleConfig.scatterOverlayView.stopScatterAnimations();

            HorribleHeroesGameModuleConfig.reelBackGroundView.killShakeTween();
        }
    }

    // #449
    private checkChanceOfFSTrigger(): boolean {
        const length: number = this._scatterSymbols.length,
            lastReelId: number = (HorribleHeroesGameConfig.instance.REELS_NUM - 1),
            sym: StateReelSymbol = this._scatterSymbols[length - 1];

        // if there are no chances of FS getting triggered, then don't play the scatter land sounds.
        return !(length === 1 && (sym.reelId === (lastReelId - 1) || sym.reelId === lastReelId)) && !(length === 2 && sym.reelId === lastReelId);
    }

    // #441
    private playXWaysLandingSound(): void {
        SoundManager.playXWaysLanding();

        if (!this._xWaysElectricitySoundPlayed) {
            this._xWaysElectricitySoundPlayed = true;
            SoundManager.playXWaysElectricity();

            // #466
            if (this._gameData.mode !== HorribleHeroesGameMode.NORMAL) {
                HorribleHeroesGameModuleConfig.logoAnimations.playAnimationsOnWin(this._gameData.mode, this._gameData.getExpandedSymbol);
            }
        }
    }

    // #395 to remove trails on spinStops
    private resetTrailSymbols(reelId: number): void {
        for (let symId = 0; symId < 4; symId++) {
            let sym: StateReelSymbol = Reels.getSymbol(reelId, symId)!;
            if (sym.symName === "X") {
                (sym as TrailReelSymbol).resetTrailOverlay(0, true);
            }
        }
    }

    // #395 to remove landing animation on spinStops
    private resetLandingAnimations(reelId: number): void {
        for (let symId = 0; symId < 4; symId++) {
            const sym: StateReelSymbol = Reels.getSymbol(reelId, symId)!;
            //#502
            if (sym.symName.indexOf("MX") > -1) {
                (sym as HorribleHeroesSymbolMX).removeLandingSpine();
            }
        }
    }
}